
.box {
  border: 1px solid var(--static-divider-standard);
  border-radius: 12px;
  overflow: hidden;
  background: var(--static-background-strong);
}
.boxHeaderWrapper {
  padding: 10px 16px;
  border-bottom: 1px solid var(--static-divider-standard);
  margin-bottom: -1px;
}
.boxHeader {
  display: flex;
  gap: 12px;
  align-items: center;
}
.boxHeader > .boxLabel {
  display: flex;
  flex: 1;
  align-items: center;
}
.boxHeader a {
  text-decoration: none;
}
.boxIcon {
  margin-right: 10px;
}
.boxItems {
  transition: height 200ms;
}
.boxItem {
  padding: 16px;
}
.boxItem:not(:last-child) {
  border-bottom: 1px dashed var(--static-divider-standard);
}

:global(body.amDraggingNDroppingGiveCursor) .boxIcon {
  filter: saturate(100%) !important;
}

@media (prefers-reduced-motion: reduce) {
  /* styles to apply if a user's device settings are set to reduced motion */
  .boxIcon.bounceBoxIconChild {
    /* @NOTE(michaelp)(pozoid): Animation duration in three places search codebase for "pozoid" */
    animation: 0.75s ease-in-out normal boxWoobWoob !important;
    animation-iteration-count: 1;
  }
  @keyframes boxWoobWoob {
    0%   { opacity: 1; }
    50%  { opacity: 0.7; }
    100% { opacity: 1; }
  }
}

.boxIcon.bounceBoxIconChild {
  /* @NOTE(michaelp)(pozoid): Animation duration in three places search codebase for "pozoid" */
  animation: 0.75s ease-in normal boxBounceFrames;
  animation-iteration-count: 1;
}
@keyframes boxBounceFrames {
  0%   { transform: scale(1,1) translateY(0%); }
  10%  { transform: scale(1.25,0.9) translateY(0%); }
  20%  { transform: scale(0.7,1) translateY(-25%); }
  30%  { transform: translateY(-47.5%); }
  40%  { transform: scale(1.1,1) translateY(-50%); }
  50%  { transform: scale(1,1) translateY(-50%); }
  60%  { transform: translateY(-45%); }
  70%  { transform: translateY(-42.5%); }
  80%  { transform: translateY(-25%); }
  90%  { transform: translateY(-15%); }
  100% { transform: translateY(0%); }
}
